import { useEffect, useState } from 'react';
import { Form, message, Breadcrumb } from 'antd';
import Box from '../../components/Box';
import Button from '../../components/Button';
import { useNavigate, useParams } from 'react-router-dom';
import styled from 'styled-components';
import accountApis from '../../services/accountApis';
import { SaveOutlined } from '@ant-design/icons';
import { useDispatch } from 'react-redux';
import { setLoading } from '../../store/loading/actions';
import { setShopState } from '../../store/shop/actions';
import dayjs from 'dayjs';
import SalonSmsCampaignCreateCustomerTable from './components/SalonSmsCampaignCreateCustomerTable';
import FilterCustomers from './components/FilterCustomers';
import SalonSmsCampCreateInfoForm from './SalonSmsCampCreateInfoForm';
import { CouponType, CreateSmsCampainBodyType } from '../../services/apisType';

export const SalonSmsCampCreatePage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [formCreate] = Form.useForm();
  const { id } = useParams();
  const [shopDate, setShopDate] = useState<any>(null);

  const onSubmit = async (values: any) => {
    try {
      if (values.typeCustomer !== 'all' && values.customers.length === 0) {
        message.error({ content: 'Please choose customer', duration: 2 });
        return;
      }
      dispatch(setLoading(true));
      const formattedDate = dayjs(values.sendTime).format('MM-DD-YYYY HH:mm:ss');
      const coupon: CouponType | null = values.isCoupon
        ? {
            couponId: '',
            discountType: values.discountType,
            discountValue: values.discountValue,
            description: values.description,
            templateCouponId:
              values.couponVisibleTemplate === 'template' ? values?.templateCouponId : '',
            title: values.couponTitle,
            totalExpireDate: values.expiresDate,
            urlImage: values.urlImage || '',
            base64:
              values.couponVisibleTemplate === 'uploadFile'
                ? values.couponImage?.replace(/^data:image\/\w+;base64,/, '')
                : '',
            subTitle: values.couponSubTitle,
          }
        : null;

      const body: CreateSmsCampainBodyType = {
        shopId: id || '',
        title: values.title,
        message: values.message,
        sendTime: formattedDate,
        coupon: coupon,
        customers: values.customers,
        campaignType: 'SMS',
        allCustomer: values.typeCustomer === 'all',
        sendNow: values.sendTimeType === 'now',
      };
      const response = await accountApis.createSmsCampaignV2(body);
      if (response.data.data) {
        message.success('Create successful');
        navigate(`/marketing/${id}#SMS_CAMPAIGN`);
      } else {
        message.error({ content: response.data.message, duration: 2 });
      }
    } catch (error: any) {
      message.error({ content: error.message as string, duration: 1 });
    } finally {
      dispatch(setLoading(false));
    }
  };

  const handleNavigate = () => {
    navigate(`/marketing/${id}#SMS_CAMPAIGN`);
  };

  const fetchInitData = async () => {
    try {
      dispatch(setLoading(true));
      if (id) {
        const resShopById = await accountApis.getShopById(id);
        if (resShopById.status === 200) {
          setShopDate(resShopById.data.data);
          dispatch(setShopState(resShopById.data.data));
        }
      }
    } catch (error: any) {
      message.error({ content: error.message as string, duration: 2 });
    } finally {
      dispatch(setLoading(false));
    }
  };

  useEffect(() => {
    fetchInitData();
  }, []);

  return (
    <CreateGiftCardPageStyled>
      <Form
        initialValues={{
          couponVisibleTemplate: 'template',
          sendTime: dayjs(),
          sendTimeType: 'now',
          isCoupon: false,
          typeCustomer: 'all',
          description:
            'For your next visit only \nValid from Monday - Thursday \nCannot combine with any other offers',
        }}
        form={formCreate}
        layout='vertical'
        onFinish={onSubmit}
      >
        <Box display='flex' justifyContent='space-between' alignItems='center'>
          <Breadcrumb
            itemRender={(route) => {
              return <div style={{ fontSize: '18px', fontWeight: 500 }}>{route.title}</div>;
            }}
            items={[{ title: 'Salon ' + shopDate?.shopName }, { title: 'Create SMS' }]}
          />

          <Box display='flex' gap={1}>
            <Button onClick={handleNavigate}>Cancel</Button>
            <Button variant='PRIMARY' htmlType='submit'>
              <SaveOutlined style={{ marginRight: '5px' }} />
              Save
            </Button>
          </Box>
        </Box>

        <ContentStyled>
          <SalonSmsCampCreateInfoForm />

          <FilterCustomers />
          <Form.Item name='customers'>
            <SalonSmsCampaignCreateCustomerTable />
          </Form.Item>
        </ContentStyled>
      </Form>
    </CreateGiftCardPageStyled>
  );
};

const CreateGiftCardPageStyled = styled.div`
  padding: 1.5rem;
  .btn-download {
    span {
      color: #1d2129;
      font-family: Poppins;
      font-size: 14px;
      font-style: normal;
      font-weight: 600;
      line-height: normal;
    }
  }
`;

const ContentStyled = styled.div`
  background: rgba(255, 255, 255, 1);
  margin-top: 1rem;
  padding: 1rem;
  background-color: white;
  min-height: 300px;
`;
